import speakingurl from 'speakingurl'
import OtherProject, { NON_POWER_PROJECT_TYPES } from './OtherProject'

class IncubatorProject extends OtherProject {
  constructor (obj) {
    super(obj)

    this.type = 'Incubator'
    this.name = obj.Facility
    this.owner = ''
    this.operator = ''
    this.id = speakingurl(`${this.name}`)

    this.city = obj.City
    this.website = obj.Website
    this.technology = obj.Technology

    this._type = NON_POWER_PROJECT_TYPES['Incubator']
    this.typeShortName = this._type.shortName
    this.icon = this._type.icon
  }
}

export default IncubatorProject



// WEBPACK FOOTER //
// ./src/models/IncubatorProject.js